import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.667 4.783a2 2 0 0 0-.496-1.318l-.09-.096-.78-.781a2 2 0 0 0-2.734-.09l-.096.09-1.138 1.137-1.529-1.528a.67.67 0 0 0-.88-.055l-.062.055-2.667 2.667a.667.667 0 0 0 .88.998l.063-.055 2.195-2.195L8.39 4.669 3.414 9.645a2.55 2.55 0 0 0-.743 1.65l-.005.155c0 .45.119.887.339 1.27l-.81.81a.667.667 0 0 0 .88.999l.063-.056.81-.809a2.55 2.55 0 0 0 2.962-.303l.113-.106 7.058-7.058a2 2 0 0 0 .582-1.282zm-1.334 0a.67.67 0 0 1-.137.406l-.058.066L12 6.393l-1.723-1.724 1.137-1.138a.67.67 0 0 1 .384-.19l.087-.006c.147 0 .29.048.406.138l.066.058.78.78a.67.67 0 0 1 .196.472"
    }, null, -1)
  ])))
}
export default { render: render }